'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PublishForm = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

var _baseButtons = require('@bibliocommons/base-buttons');

var _utilsList = require('@bibliocommons/utils-list');

var _constantsList = require('@bibliocommons/constants-list');

var _visibilitySelector = require('../../visibility-selector');

var _visibilitySelector2 = _interopRequireDefault(_visibilitySelector);

require('../styles/PublishForm.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PublishForm = exports.PublishForm = function (_BcReactComponent) {
  _inherits(PublishForm, _BcReactComponent);

  function PublishForm(props) {
    _classCallCheck(this, PublishForm);

    var _this = _possibleConstructorReturn(this, (PublishForm.__proto__ || Object.getPrototypeOf(PublishForm)).call(this, props));

    _this.bindAll('handleVisibilityChange', 'handleVisibilityLocationChange', 'handlePublish');

    var visibility = _this.props.list.get('publishedListId') ? (0, _utilsList.getListVisibilityType)(_this.props.list) : _constantsList.VISIBILITY.EVERYWHERE;
    _this.state = {
      visibility: visibility,
      visibilityLocation: _this.props.list.get('intendedLocale')
    };
    return _this;
  }

  _createClass(PublishForm, [{
    key: 'handlePublish',
    value: function handlePublish() {
      var data = {
        agencyScope: 'current_agency',
        intendedLocale: 'everywhere',
        visibility: this.state.visibility
      };

      if (this.state.visibility === _constantsList.VISIBILITY.GEOFENCED) {
        data.intendedLocale = this.state.visibilityLocation;
      }

      this.props.handlePublish(data);
    }
  }, {
    key: 'handleVisibilityChange',
    value: function handleVisibilityChange(visibility) {
      this.setState({ visibility: visibility });
    }
  }, {
    key: 'handleVisibilityLocationChange',
    value: function handleVisibilityLocationChange(visibilityLocation) {
      this.setState({ visibilityLocation: visibilityLocation });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'form',
        {
          action: '',
          onSubmit: PublishForm.handleSubmit,
          'data-test-id': 'publish-list-form',
          className: 'cp-publish-overlay' },
        _react2.default.createElement(
          'div',
          { className: 'publish-subtitle' },
          _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'user_list_ready_to_publish' })
        ),
        _react2.default.createElement(_visibilitySelector2.default, {
          listLocales: this.props.listLocales,
          visibility: this.state.visibility,
          location: this.state.visibilityLocation,
          handleVisibilityChange: this.handleVisibilityChange,
          handleVisibilityLocationChange: this.handleVisibilityLocationChange }),
        _react2.default.createElement(
          'div',
          { className: 'buttons' },
          _react2.default.createElement(
            _baseButtons.TextButton,
            {
              'data-test-id': 'publish-list-cancel-button',
              type: 'button',
              handleClick: this.props.handleClose },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'button_cancel' })
          ),
          _react2.default.createElement(
            _baseButtons.PrimaryButton,
            {
              'data-test-id': 'publish-list-submit-button',
              type: 'button',
              handleClick: this.handlePublish },
            _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'publish_btn' })
          )
        )
      );
    }
  }], [{
    key: 'handleSubmit',
    value: function handleSubmit(e) {
      e.preventDefault();
    }
  }]);

  return PublishForm;
}(_baseBcReactComponent2.default);

PublishForm.propTypes = {
  list: _bcPropTypes.listShape.isRequired,
  listLocales: _reactImmutableProptypes2.default.map.isRequired,

  handleClose: _react.PropTypes.func.isRequired,
  handlePublish: _react.PropTypes.func.isRequired
};

exports.default = PublishForm;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/publish-form/components/PublishForm.component.js
// module id = 1329
// module chunks = 0